import React from 'react';
import Hooks from '@benzinga/hooks';
import { checkDeviceType, DeviceType } from '@benzinga/device-utils';

const ReadInAppButton = React.lazy(() => import('./ReadInAppButton'));
const GoogleNewsButton = React.lazy(() => import('./GoogleNewsButton'));
const AppleNewsButton = React.lazy(() => import('./AppleNewsButton'));

interface Props {
  googleNewsUrlKey?: 'benzinga' | 'benzingaIndia';
  deviceType?: DeviceType | null;
  showAdvertiserDisclosure?: boolean;
}

export const MobileShareButtons: React.FC<Props> = ({ deviceType, googleNewsUrlKey, showAdvertiserDisclosure }) => {
  const isApple = Hooks.useHydrate(checkDeviceType().isApple(), false);

  return (
    <>
      {googleNewsUrlKey === 'benzingaIndia' ? (
        <GoogleNewsButton urlKey={googleNewsUrlKey} />
      ) : !showAdvertiserDisclosure && isApple ? (
        <AppleNewsButton />
      ) : deviceType === 'mobile' ? (
        <ReadInAppButton />
      ) : (
        <GoogleNewsButton />
      )}
    </>
  );
};
